import Vue from 'vue'
import Vuex from 'vuex'   //引入vuex
import mutations from './mutations' //mutations中， 用于定义state中的属性， 用于定义事件去控制state中属性的变化, 定义getter
import actions from './actions' //用于外部声明事件，并去commit触发mutations中的事件

Vue.use(Vuex);


export default new Vuex.Store({
	modules:{
		mutations   //加载到Modules中
	},
	actions
});




// WEBPACK FOOTER //
// ./src/store/store.js